import { useState, useEffect } from 'react';

const slides = [
  { image: 'https://readdy.ai/api/search-image?query=girls%20bar%20interior%20Japan%2C%20light%20blue%20color%20scheme%20AAC4DC%2C%20powder%20blue%20walls%20and%20decor%2C%20elegant%20counter%20seats%2C%20soft%20blue%20ambient%20lighting%2C%20white%20and%20light%20blue%20interior%2C%20cozy%20feminine%20atmosphere%2C%20modern%20Japanese%20bar%20design%2C%20beautiful%20blue%20toned%20decor%2C%20intimate%20setting%2C%20high%20quality%20photography&width=1920&height=1080&seq=hero_a1&orientation=landscape' },
  { image: 'https://readdy.ai/api/search-image?query=Japanese%20girls%20bar%20interior%2C%20light%20sky%20blue%20color%20palette%2C%20powder%20blue%20bar%20counter%2C%20soft%20blue%20lighting%2C%20white%20and%20blue%20elegant%20decor%2C%20feminine%20cozy%20atmosphere%2C%20stylish%20blue%20toned%20bar%20space%2C%20modern%20design%2C%20inviting%20ambiance%2C%20professional%20photography&width=1920&height=1080&seq=hero_a2&orientation=landscape' },
  { image: 'https://readdy.ai/api/search-image?query=cozy%20Japanese%20bar%20lounge%20interior%2C%20light%20blue%20and%20white%20color%20scheme%2C%20powder%20blue%20seating%20area%2C%20soft%20blue%20ambient%20lighting%2C%20elegant%20feminine%20decor%2C%20modern%20minimalist%20design%2C%20relaxing%20blue%20toned%20atmosphere%2C%20beautiful%20bar%20space%2C%20high%20end%20photography&width=1920&height=1080&seq=hero_a3&orientation=landscape' },
];

export default function HeroSlider() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full overflow-hidden" style={{ height: '100vh', minHeight: '560px' }}>
      {slides.map((slide, i) => (
        <div
          key={i}
          className="absolute inset-0 transition-opacity duration-1000"
          style={{ opacity: i === current ? 1 : 0 }}
        >
          <img
            src={slide.image}
            alt=""
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      {/* Dark overlay */}
      <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.35)' }} />

      {/* Caption - left aligned like original */}
      <div className="absolute inset-0 flex flex-col justify-end pb-24 px-8 md:px-20">
        <h2
          className="text-white text-3xl md:text-5xl font-light leading-relaxed mb-4"
          style={{
            fontFamily: "'Noto Serif JP', serif",
            textShadow: '0 2px 16px rgba(0,0,0,0.6)',
            letterSpacing: '0.15em',
          }}
        >
          笑顔と癒し<br />心を満たすひととき
        </h2>
        <p
          className="text-white/90 text-sm md:text-base leading-loose"
          style={{ textShadow: '0 1px 8px rgba(0,0,0,0.7)', letterSpacing: '0.05em' }}
        >
          桜木町エリアの、あたたかいガールズバー。<br />
          お一人様からグループまで、気軽にお立ち寄りください。<br />
          笑顔のスタッフが、心を込めてお迎えします。
        </p>
      </div>

      {/* Dots */}
      <div className="absolute bottom-8 left-0 w-full flex justify-center gap-2">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className="cursor-pointer transition-all duration-300"
            style={{
              width: i === current ? '24px' : '8px',
              height: '8px',
              borderRadius: '4px',
              background: i === current ? '#fff' : 'rgba(255,255,255,0.5)',
              border: 'none',
              padding: 0,
            }}
          />
        ))}
      </div>
    </section>
  );
}
